import React, { useEffect, useContext } from "react";

import MapIcon from "./MapIcon.jsx"
import Result from "./Result.jsx"
import { DealerContext } from "@contexts/DealerContext.jsx";

const MapItem = ({dealers, index, center, lat, lng, inContextResult = true}) => {

  const { openDealerId, hoverIndex, setOpenDealerId, setOpenDealers } = useContext(DealerContext);

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setOpenDealerId(dealers[0].id);
    setOpenDealers([...dealers]);
  }
  const handleClose = () => {
    setOpenDealerId(null);
    setOpenDealers([]);
  }

  useEffect(() => {
    if(openDealerId){
      dealers.forEach((dealer, index) => {
        if(dealer.id == openDealerId){
          setPage(index + 1);
        }
      });
    }
  }, [openDealerId]);

  const page = dealers.findIndex(dealer => dealer.id == openDealerId) + 1;

  const top = center.lat - lat;
  const right = center.lng - lng;
  let orientation = "bottom";

  if(Math.abs(top) > Math.abs(right)){
    orientation = top > 0 ? "top" : "bottom";
  }else{
    orientation = right > 0 ? "right" : "left";
  }

  const setPage = (page) => {
    setOpenDealerId(dealers[page - 1].id);
  }


  var preferredDealer = dealers.find((dealer) => {
    return dealer.preferred_dealer;
  });
  if(!preferredDealer){
    preferredDealer = dealers.find((dealer) => {
      return dealer.specialty_retail_dealer;
    });
  }

  const open = dealers.find((dealer) => openDealerId == dealer.id);

  return (
    <div className={`ft_dealer-locator__map__icon-container ${open ? "open" : ""}`} data-index={index}>
      <MapIcon hover={hoverIndex == index} open={open} dealer={preferredDealer || dealers[0]} quantity={dealers.length} onClick={handleClick}/>
      { inContextResult && open ? (() => {

          return <div className={`ft_dealer-locator__map__result ${orientation}`}>
                    <div className="ft_dealer-locator__dealer__close" onClick={handleClose}>&times;</div>
                    {dealers.slice(page - 1, page).map( (dealer, index) => <Result key={"result" + index} dealer={dealer} index={index} showIcon={false} /> )}
                    {dealers.length > 1 && <div className="ft_dealer-locator__dealer__pagination">
                        { page > 1 ? <a onClick={()=>{setPage(page - 1)}} className="ft_dealer-locator__dealer__pagination__link">&lt; Prev</a>
                          :<div className="ft_dealer-locator__dealer__pagination__link--placeholder"></div>}
                        <div className="ft_dealer-locator__dealer__pagination__text">{`${page} of ${dealers.length}`}</div>
                        { page < dealers.length ? <a onClick={()=>{setPage(page + 1)}} className="ft_dealer-locator__dealer__pagination__link">Next &gt;</a>
                          :<div className="ft_dealer-locator__dealer__pagination__link--placeholder"></div>}
                      </div>}
                  </div>
        })()
      : null }
    </div>
  );
}

export default MapItem;
